export const userSearchBarInitialValues = {
  is_paid: {
    label: 'Both',
    value: null,
  },
  search: '',
};
